import {atom} from 'recoil';

export const raDetailState = atom<any>({
    key: 'raDetail',
    default: null
});